import { useDispatch, useSelector } from "react-redux"
import { Button, Col, Form, Row, Select, message, Spin, Typography, Descriptions, Tag, Checkbox } from "antd"
import { useEffect, useState } from "react"
import { getDataInfo, stepperMoving } from "../../stores/actions";
import { request } from '../../../../shared/src/apis';
import { assignUnidentifiedCollectionForCompanyApi, createExternalPaymentApi, getInvoiceSerialNumbersApi, getOneCompanyApi, getPaymentCyclesApi, getUserInfoApi, submitExternalPaymentWithEarlySettlmentApi } from "../../utils/apisConsts"
import { OutPutResult } from '@operations/shared';
import helper from "../../utils/helper";
import { errorMessage } from "../../utils/commonStringsConsts";
import moment from 'moment';
import { useForm } from "antd/es/form/Form";
import { paymentTypes } from "../../utils/commonInterfaces";
import UserSettlementDetails from "../../components/UserSettlementDetails";

const { Option } = Select;
const { Text } = Typography

const AssignUnidentifiedCollection = ({ identifier, isCompany, setIsCompany }: { identifier: any, isCompany: boolean, setIsCompany: any }) => {
    const [form] = useForm()
    const dispatch = useDispatch()
    const unidentifiedCollectionInfo = useSelector((state: any) => state.actionsReducer.unidentifiedCollectionInfo);
    const [loadingData, setLoadingData] = useState(false)
    const [errorMode, setErrorMode] = useState(false)
    const [data, setData] = useState<any>({})
    const [isLoadingAssign, setIsLoadingAssign] = useState(false)
    const [invoiceSerialNumbers, setInvoiceSerialNumbers] = useState<{ paymentCycle: number, serialNumber: string }[]>([])
    const [paymentCycles, setPaymentCycles] = useState<{ id: number, paymentCycle: number, cutOffCycleDate: string, isLocked: boolean }[]>([])
    const [fullEarlySettlement, setFullEarlySettlement] = useState<any>({})
    const [selectedPaymentCycle, setSelectedPaymentCycle] = useState<number>(0);
    const isDiscountApplied = Form.useWatch('isDiscountApplied', form);
    const paymentType = Form.useWatch('paymentType', form);
    const paymentCycleForm = Form.useWatch('paymentCycle', form);

    useEffect(() => {
        setLoadingData(true)
        if (isCompany) {
            getData()
                .then((payer) => getInvoiceSerialNumbers(payer))
                .then(() => setLoadingData(false))
        } else {
            getData()
                .then((payer) => getPaymentCycles(payer))
                .then(() => setLoadingData(false))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getData = async () => {
        try {
            const resData: { [key: string]: any } = await dispatch(request({ url: isCompany ? `${getOneCompanyApi}/${identifier}` : `${getUserInfoApi}?phone=${identifier}` }))
            if (resData?.data?.status === 200) {
                setData(isCompany ? resData?.data?.data : resData?.data?.userInfo)
                isCompany && dispatch(getDataInfo(resData?.data?.data))
                return resData?.data
            } else {
                message.error(resData?.data?.message)
                setErrorMode(true)
            }
        }
        catch (error: any) {
            setErrorMode(true)
            setLoadingData(false)
        }
    }

    const getPaymentCycles = async (payer: { [key: string]: any }) => {
        const params = {
            companyID: payer?.userInfo?.companyID,
            mostRecent: true
        }
        try {
            const paymentCyclesRes: { [key: string]: any } = await dispatch(request({ url: getPaymentCyclesApi, method: "GET", params: params }))
            if (paymentCyclesRes.data.status === 200) {
                const todayDate = new Date()
                const payerDate = new Date()
                payerDate.setDate(payer?.userInfo?.actualCutOffDate)
                if (payerDate <= todayDate) {
                    payerDate.setMonth(payerDate.getMonth() + 1)
                }
                const currentCycle = {
                    cutOffCycleDate: payerDate,
                    paymentCycle: Number(paymentCyclesRes?.data?.allPaymentCycles?.paymentCycle) + 1
                }
                setPaymentCycles([paymentCyclesRes?.data?.allPaymentCycles, currentCycle])
            } else {
                message.error(paymentCyclesRes?.data?.message)
                setErrorMode(true)
            }
        }
        catch (error: any) {
            setErrorMode(true)
            setLoadingData(false)
        }
    }

    const getInvoiceSerialNumbers = async (payer: { [key: string]: any }) => {
        try {
            const res: { [key: string]: any } = await dispatch(request({ url: getInvoiceSerialNumbersApi + (isCompany ? identifier : payer?.userInfo?.companyID), method: "GET" }))
            if (res?.data?.status === 200) {
                setInvoiceSerialNumbers(res?.data?.data?.invoicesSerialNumber)
            } else {
                message.error(errorMessage)
                setErrorMode(true)
            }
        }
        catch (error: any) {
            message.error(errorMessage)
            setErrorMode(true)
        } finally {
            setLoadingData(false)
        }
    }

    const paymentTypeChange = (value: number) => {
        if (value === paymentTypes.fullSettlement) {
            const cycle = form.getFieldValue('paymentCycle') ?? selectedPaymentCycle;
            if (!cycle) {
                form.setFieldsValue({ paymentType: null });
                message.error('Please select invoice month first');
            }
        }
    }

    const handleSelectInvoiceMonth = (cycle: number) => {
        setSelectedPaymentCycle(cycle);
        !form.getFieldValue('paymentType') && form.setFieldsValue({ paymentType: paymentTypes.partialSettlement });
    }

    useEffect(() => {
        setFullEarlySettlement((prev: any) => {
            if (prev?.dueAmountBeforeDiscount == null || prev?.dueAmountAfterDiscount == null) return prev;
            return { ...prev, dueAmount: isDiscountApplied ? prev.dueAmountAfterDiscount : prev.dueAmountBeforeDiscount };
        });
    }, [isDiscountApplied]);

    const handleAssignUnidentifiedCollectionForCompany = async (values: any) => {
        setIsLoadingAssign(true)
        const selectedInvoice = invoiceSerialNumbers?.find((invoice) => invoice?.serialNumber === values?.invoiceSerialNumber)
        const assignData = {
            companyID: identifier,
            paymentCycle: selectedInvoice?.paymentCycle,
            serialNumber: values?.invoiceSerialNumber,
            unidentifiedCollectionID: unidentifiedCollectionInfo?.id,
        }
        try {
            const res: { [key: string]: any } = await dispatch(request({ url: assignUnidentifiedCollectionForCompanyApi, method: "POST", data: assignData }))
            if (res?.data?.status === 200) {
                message.success(res?.data?.message)
                dispatch(stepperMoving(0))
            } else {
                message.error(res?.data?.status === 400 ? res?.data?.message : errorMessage)
            }
        }
        catch (error: any) {
            message.error(error?.response?.status === 400 ? error?.response?.data?.message : errorMessage)
        } finally {
            setIsLoadingAssign(false)
        }
    }

    const handleAssignUnidentifiedCollectionForUser = async (values: any) => {
        if (values?.paymentType !== paymentTypes.partialSettlement) {
            if (values?.isDiscountApplied) {
                if (unidentifiedCollectionInfo?.amount < fullEarlySettlement?.dueAmount - fullEarlySettlement?.totalEarlySettlementDiscount) {
                    message.error("External payment amount should be greater than or equal due amount.")
                    return;
                }
            } else {

                if (unidentifiedCollectionInfo?.amount < fullEarlySettlement?.dueAmount) {
                    message.error("External payment amount should be greater than or equal due amount.")
                    return;
                }
            }
        }
        const partialPaymentBody = {
            userID: data?.userID,
            startEarly: values?.paymentType,
            paymentCycle: values?.paymentCycle,
            amount: unidentifiedCollectionInfo?.amount,
            collectionDate: unidentifiedCollectionInfo?.collectionDate,
            unidentifiedID: unidentifiedCollectionInfo?.id,
        }
        const fullSettlementBody = {
            userID: data?.userID,
            externalpaymentAmount: unidentifiedCollectionInfo?.amount,
            collectionDate: unidentifiedCollectionInfo?.collectionDate,
            applyDiscount: values?.isDiscountApplied ?? false,
            paymentCycle: values?.paymentCycle,
            unidentifiedID: unidentifiedCollectionInfo?.id,
        }
        const handler: { api: string, buildBody: any } = {
            [paymentTypes?.partialSettlement]: {
                api: createExternalPaymentApi,
                buildBody: partialPaymentBody
            },
            [paymentTypes?.fullSettlement]: {
                api: submitExternalPaymentWithEarlySettlmentApi,
                buildBody: fullSettlementBody
            }
        }[values?.paymentType as paymentTypes];
        try {
            setIsLoadingAssign(true)
            const res: { [key: string]: any } = await dispatch(request({ url: handler.api, method: "POST", data: handler.buildBody }))
            if (res?.data?.status === 200) {
                message.success(res?.data?.message)
                setIsCompany(true)
                dispatch(stepperMoving(0))
            } else {
                message.error(res?.data?.status === 405 || res?.data?.status === 400 ? res?.data?.message : errorMessage)
            }
        }
        catch (error: any) {
            message.error(error?.response?.status === 405 || error?.response?.status === 400 ? error?.response?.data?.message : errorMessage)
        } finally {
            setIsLoadingAssign(false)
        }
    }

    return (
        errorMode ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage ? errorMessage : 'Something went wrong, please refresh the page and try again'}
            btnTitle={'Refresh the page'} btnClick={helper.refreshPage} /> :
            <div className="createEarlyPayment">
                <Spin size="large" spinning={loadingData}>
                    <Form name="nest-messages" onFinish={isCompany ? handleAssignUnidentifiedCollectionForCompany : handleAssignUnidentifiedCollectionForUser} form={form} style={{ marginTop: '1rem' }}>
                        <Row className="inputsRow">
                            {isCompany ? (
                                <>
                                    <Col span='12'>
                                        <label>Invoice <span>*</span></label>
                                        <Form.Item
                                            name="invoiceSerialNumber"
                                            rules={[{ required: true, message: 'Required' }]}
                                        >
                                            <Select placeholder="Select Invoice serial number">
                                                {invoiceSerialNumbers?.map((invoice) => <Option key={invoice.serialNumber} value={invoice.serialNumber}>{invoice.serialNumber}</Option>)}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </>
                            ) : (
                                    <>
                                        <Col span='12'>
                                            <label>Invoice Month <span>*</span></label>
                                            <Form.Item
                                                name="paymentCycle"
                                                rules={[{ required: true, message: 'Required' }]}
                                            >
                                                <Select placeholder="Select Invoice month" onChange={handleSelectInvoiceMonth}>
                                                    {paymentCycles?.map((paymentCycle) => <Option key={paymentCycle.id} value={paymentCycle.paymentCycle} disabled={paymentCycle.isLocked}>{moment(paymentCycle.cutOffCycleDate).format('Do MMM, YYYY')}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span='12'>
                                            <label>Payment types <span>*</span></label>
                                            <Form.Item
                                                name="paymentType"
                                                rules={[{ required: true, message: 'Required' }]}
                                            >
                                                <Select placeholder="Select an payment type" onChange={paymentTypeChange}>
                                                    <Option value={1}>Partial Settlement</Option>
                                                    <Option value={0}>Full Settlement</Option>
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        {paymentType === paymentTypes.fullSettlement && (
                                            <Col span='24'>
                                                <Form.Item name="isDiscountApplied" valuePropName="checked">
                                                    <div style={{ display: 'flex', paddingTop: '27px', gap: '8px' }}>
                                                        <Checkbox />
                                                        <label>Apply Discount</label>
                                                    </div>
                                                </Form.Item>
                                            </Col>
                                        )}
                                    </>
                            )}
                        </Row>
                        {!loadingData && <Row style={{ justifyContent: 'end' }}>
                            <Col span='' className="btnCol">
                                <Form.Item>
                                    <Button shape="round" type="primary" block htmlType="submit" style={{ marginTop: '0.5rem', paddingInline: '1.5rem' }} loading={isLoadingAssign} disabled={isLoadingAssign}>
                                        Submit
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>}
                    </Form>
                </Spin>
                <Descriptions
                    title="Collection Details"
                    bordered
                    column={1}
                    size="small"
                    labelStyle={{
                        fontWeight: 600,
                        backgroundColor: "#fafafa",
                        width: "40%",
                    }}
                    contentStyle={{
                        backgroundColor: "#fff",
                        fontWeight: 500,
                    }}
                    style={{ marginBottom: '1rem' }}
                >
                    <Descriptions.Item label="Collection Amount">
                        <Tag color="green">{unidentifiedCollectionInfo?.amount} </Tag>
                    </Descriptions.Item>

                    <Descriptions.Item label="Collection Date">
                        <Text strong>{moment(unidentifiedCollectionInfo?.collectionDate).format('LL')}</Text>
                    </Descriptions.Item>

                    <Descriptions.Item label="comment">
                        <Text>{unidentifiedCollectionInfo?.comment ?? 'NA'}</Text>
                    </Descriptions.Item>
                </Descriptions>
                {!isCompany &&
                    <UserSettlementDetails
                        userInfo={data}
                        paymentType={paymentType}
                        amount={unidentifiedCollectionInfo?.amount ?? 0}
                        isDiscountApplied={isDiscountApplied}
                        selectedPaymentCycle={paymentCycleForm ?? selectedPaymentCycle}
                        fullEarlySettlement={fullEarlySettlement}
                        setFullEarlySettlement={setFullEarlySettlement} />}
            </div>
    )
}

export default AssignUnidentifiedCollection